import { render, staticRenderFns } from "./ActivationBriefTaskDeliveryInstagramStoryView.vue?vue&type=template&id=5653fdbf&scoped=true&"
import script from "./ActivationBriefTaskDeliveryInstagramStoryView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTaskDeliveryInstagramStoryView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefTaskDeliveryInstagramStoryView.vue?vue&type=style&index=0&id=5653fdbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653fdbf",
  null
  
)

export default component.exports